<template>
  <div class="expert-page">

    <div class="middle-main">

      <!-- <column-title title="Famous Column" :desc="L('名家专栏')" /> -->
      <el-row :gutter="isPc == 1 ? 30 : isPc == 2 ? 20 : 0" class="expert-row">
        <el-col :span="isPc == 1 ? 16 : isPc == 2 ? 16 : 24">
          <h1 class="title">名家專欄</h1>
          <news-list typeId="19" :img-direction="isPc !== 3 ? 'flex-row' : 'flex-col'" type="expert" />
        </el-col>
        <el-col :span="isPc == 1 ? 8 : isPc == 2 ? 8 : 24">
          <div class="like-news">
            <h3>
              熱門專家
              <span class="change">
                <svg-icon icon-class="change"></svg-icon>
                <span @click="changeHotExpertList">换一批</span>
              </span>
            </h3>
            <Person :list="expertList" />
            <div class="line" v-if="isPc != 3"></div>
            <h3>
              熱門专题
              <span class="change">
                <svg-icon icon-class="change"></svg-icon>
                <span @click="changeHotList">换一批</span>
              </span>
            </h3>
            <News :list="expertHotList" />

            <!-- <news-list typeId="20" img-direction="flex-col" :ispagination="false"/> -->
          </div>
        </el-col>
      </el-row>
      <!-- <div class="wrapper">

        <div class="bg-white main-content">
          <Banner :list="expertNewsList.slice(0, 3)" />
          <Cards :list="expertNewsList.slice(3, 6)" />
          <Divider />
          <List :list="expertNewsList.slice(3, 6)" />
        </div>

        <div class="bg-white" style="flex: 1;flex-shrink: 0;">
          <Person :list="expertList" />
          <div class="bg-grey" style="padding-bottom: 16px;">
          </div>
          <News :list="expertHotList" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import columnTitle from '../common/column-title.vue'
import NewsList from '../common/news-list.vue'
import Banner from "./banner.vue";
// import Cards from './cards.vue'
import Divider from './divider.vue'
import List from './list.vue'
import Person from './person.vue'
import { mapState } from "vuex";
import News from "./news.vue";

import { getNewsList, getExpertList } from "@/assets/api/news.js";

export default {
  components: {
    columnTitle,
    Banner,
    // Cards,
    Divider,
    List,
    Person,
    News,
    NewsList,
  },
  computed: {
    ...mapState(["isPc"]),
  },
  data() {
    return {
      expertList: [],
      expertNewsList: [],
      expertHotList: [],
      allHotList: [],
      allExpertList: []
    };
  },
  created() {
    getExpertList({
      pageNum: 1,
      pageSize: 30,
    }).then((res) => {
      console.log('expert-person-list', res.data.rows)
      this.allExpertList = res.data.rows
      //随机从res.data.rows中取8条
      this.expertList = res.data.rows.sort(() => Math.random() - 0.5).slice(0, 8).map((item) => {
        item.newsImage = item.newsImage ? !/^http/.test(item.newsImage)
          ? this.$imgUrl + item.newsImage
          : item.newsImage : '';
        item.author=item.authorV2?item.authorV2:item.author;
        item.authorAvatar=item.authorAvatarV2?item.authorAvatarV2:item.authorAvatar;
        item.authorAvatar = item.authorAvatar ? !/^http/.test(item.authorAvatar)
          ? this.$imgUrl + item.authorAvatar
          : item.authorAvatar : '';
        return item;
      });
    });

    getNewsList({
      orderByColumn: "releaseTime",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 10,
      slideshow: 0,
      typeId: 19
    }).then((res) => {
      console.log('expert-news-list', res.data.rows)
      this.expertNewsList = res.data.rows.map((item) => {
        item.newsImage = !/^http/.test(item.newsImage)
          ? this.$imgUrl + item.newsImage
          : item.newsImage;
        return item;
      });
    });

    getNewsList({
      orderByColumn: "tips",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 50,
      slideshow: 0,
      typeId: 19
    }).then((res) => {
      console.log('expert-hot-list', res.data.rows)
      //随机从res.data.rows中取5条
      this.allHotList = res.data.rows
      this.expertHotList = res.data.rows.sort(() => Math.random() - 0.5).slice(0, 5)
    });
  },
  methods: {
    changeHotExpertList() {
      this.expertList = this.allExpertList.sort(() => Math.random() - 0.5).slice(0, 8).map((item) => {
        item.newsImage = item.newsImage ? !/^http/.test(item.newsImage)
          ? this.$imgUrl + item.newsImage
          : item.newsImage : '';
        item.author=item.authorV2?item.authorV2:item.author;
        item.authorAvatar=item.authorAvatarV2?item.authorAvatarV2:item.authorAvatar;
        item.authorAvatar = item.authorAvatar ? !/^http/.test(item.authorAvatar)
          ? this.$imgUrl + item.authorAvatar
          : item.authorAvatar : '';
        return item;
      });
    },
    changeHotList() {
      this.expertHotList = this.allHotList.sort(() => Math.random() - 0.5).slice(0, 5)
    }
  }

};
</script>


<style lang="less" scoped>
.expert-page {
  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin: 40px 0 30px;
  }
}

.like-news {

  h3 {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px 0 30px;

    span {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #AEAEB2;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      cursor: pointer;
    }

    .change {
      &:hover {
        span {
          color: #E2291E;
        }

        color: #E2291E;
      }
    }

  }
}

.line {
  width: 100%;
  height: 1px;
  background-color: #E5E5EA;
  margin: 10px 0 20px;
}

.wrapper {
  display: flex;
  padding-bottom: 75px;
}

.main-content {
  width: 70%;
  margin-right: 16px;
}

@media screen and (max-width: 768px) {
  .expert-row {
    display: flex;
    flex-direction: column-reverse;
  }

  .expert-page {
    .title {
      font-size: 24px;
      line-height: 32px;
    }

    padding: 0 20px;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
  }

  .main-content {
    width: 100%;
    margin-right: 0;
    border-bottom: 16px solid #edeff1;
  }

  .like-news {
    h3 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 24px;
      color: #2C2C2E;
      line-height: 31px;
      text-align: left;
      font-style: normal;
      margin: 30px 0 20px;

      span {
        font-size: 12px;
        line-height: 16px;
        display: flex;
        align-items: center;

        .svg-icon {
          width: 11px;
          height: 11px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/expert/index.vue